import ApplicationController from './application_controller';

// Polls the current page while a GaiCall is in `pending` status, reloading
// every N milliseconds until the server-rendered status changes. Used by
// the show page when the call was queued as a background job; once the
// job updates the GaiCall to completed/failed, the next reload picks up
// the new state and the controller stops polling automatically (because
// the alert element with this controller is no longer rendered).
export default class extends ApplicationController {
  static values = {
    status: String,
    interval: { type: Number, default: 3000 },
  };

  connect() {
    if (this.statusValue !== 'pending') return;
    this.timer = window.setTimeout(() => window.location.reload(), this.intervalValue);
  }

  disconnect() {
    if (this.timer) window.clearTimeout(this.timer);
  }
}
